import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { fetchAuthSession } from "aws-amplify/auth";
import App from "./App";
import "./styles/index.css";
import "./styles/animations.css";

// AWS LCCS (OutpostForge) module styles + auth wiring
import "@/features/outpostforge/components/visualizer.css";
import { setAuthTokenProvider } from "@/features/outpostforge/services/http";

// Configuración de Amplify con Okta SAML
import { configureAmplify } from "./config/amplify-config";
import reportWebVitals from "./utils/reportWebVitals";
import logger from "./utils/secureLogger";

// Configurar Amplify con integración de Okta
configureAmplify();

// El módulo AWS LCCS no habla con Amplify directamente: le inyectamos el
// proveedor de token de la sesión de Cognito del portal. Cada request del
// módulo llevará "Authorization: Bearer <idToken>".
setAuthTokenProvider(async () => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch (error) {
    logger.warn("No se pudo obtener el token de sesión para AWS LCCS", {
      message: error?.message,
    });
    return null;
  }
});

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

reportWebVitals();
